
<div data-e2e-id="styleguide-customroutetype">
  <h3 *scText="contextFields.headline"></h3>

  <p>
    <em>
      By <span *scText="contextFields.author"></span>
    </em>
  </p>

  <div *scRichText="contextFields.content"></div>

  <a routerLink="/styleguide">Return to the Styleguide</a>
</div>
